import React from "react";
import "./styles.scss";
import Button from "../../../common/button";
import { pdpfDownload } from "../../../store/homeAction/action";
import { useStateValue } from "../../../store";
import Constant from "../../../Constant";

const NextStep = (props) => {
  const [{}, dispatch] = useStateValue();
  // const { description, title, description_for_low_score } = props;

  const handlePDFdownload = () => {
    //api call
    let payload = {
      email: "",
      name: "",
      assesment_for: JSON.parse(sessionStorage.getItem("qtnValues"))
        ?.identify_person,
      assesment: [
        ...Object.entries(
          JSON.parse(sessionStorage.getItem("qtnValues"))?.question
        ).map(([__, answer]) => ({
          question_no: parseInt(answer?.id),
          answer: answer?.value,
        })),
      ],
    };
    dispatch({
      type: "SET_IS_LOADING",
      value: true,
    });
    pdpfDownload((res, error) => {
      dispatch({
        type: "SET_IS_LOADING",
        value: false,
      });

      if (res?.status) {
        window.open(res?.data, "_blank"); // Opens the PDF in a new tab
      } else {
        dispatch({
          type: "SET_ALERT_MESSAGE",
          value: true,
          data: { severity: "error", message: res?.data },
        });
      }
      if (error) {
        dispatch({
          type: "SET_ALERT_MESSAGE",
          value: true,
          data: {
            severity: "error",
            message: "Something went wrong, Please try again.",
          },
        });
      }
    }, payload);
  };

  return (
    <div className="next-step-container">
      {/* <div className="h3">
        <h3>Your next steps</h3>
      </div>
      <div className="description">
        <h4>{title}<span>:</span></h4>
        <p
          dangerouslySetInnerHTML={{
            __html: description_for_low_score?.length
              ? description_for_low_score
              : description,
          }}
        />
      </div> */}
      <div className="description">
        <h4>Click here to download your Fall risk report</h4>
      </div>
      <Button onClick={() => handlePDFdownload()}>
        Download your detailed report
      </Button>
    </div>
  );
};

export default NextStep;
